<div class="direct-debit" *ngIf="contents && res">
    <div class="success-debit">
        <div class="main-banner" [ngStyle]="{ background: bgImg }">
            <h2>{{ contents.success.title }}</h2>
            <h3>{{ contents.success.subTitle }}</h3>
        </div>
        <div class="content">
            <div class="main-title">
                <img [src]="contents.success.iconImage" alt="" class="hand" />
                <div *ngIf="isPartialSuccess; else partialSuccess">
                    <h1>{{ contents.success.partMessage }}</h1>
                    <h2>{{ contents.success.partMessageSub }}</h2>
                </div>
                <ng-template #partialSuccess>
                    <h1>{{ contents.success.message }}</h1>
                    <h2>{{ contents.success.messageSub }}</h2>
                </ng-template>
            </div>
            <div class="middle-content">
                <div class="transfer-from">
                    <div class="card-wrapper first-card">
                        <h3>העברת הוראות הקבע מ:</h3>
                        <div class="my-card" *ngFor="let card of res.fromCard">
                            <img [src]="card.cardImage" alt="" class="card-pic" />
                            <div class="details">
                                <span class="number">{{ card.shortCardNumber }}</span>
                                <span class="type">{{ card.cardName }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-wrapper">
                        <h3>העברה לכרטיס:</h3>
                        <div class="my-card">
                            <img [src]="res.toCard.cardImage" alt="" class="card-pic" />
                            <div class="details">
                                <span class="number">{{ res.toCard.shortCardNumber }}</span>
                                <span class="type">{{ res.toCard.cardName }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="transfer-info" *ngIf="isPartialSuccess">
                        <span>
                            הועברו בהצלחה <span class="num">{{ successCount }}</span> מתוך
                            <span class="num">{{ total }}</span>
                            הוראות קבע
                        </span>
                        <span (click)="showStandingOrderData()" class="info">פירוט</span>
                    </div>
                </div>

                <h4>{{ contents.success.disclosure }}</h4>
                <div class="button-wrapper">
                    <a (click)="goBackHome()" class="brand-button red-button" title=""><span>חזרה לעמוד הבית</span></a>
                </div>
            </div>
            <div class="terms">
                <p>
                    {{ contents.success.asterix }}
                </p>
            </div>
        </div>
    </div>
</div>
